import { type RefObject, createContext } from 'react';

type VideoControlContextType = {
  headerVideoRef: RefObject<HTMLVideoElement | null>;
};

export const VideoControlContext = createContext<null | VideoControlContextType>(null);
